<template>
<label
    class="flex items-center space-x-3">
<div class="flex flex-none items-center justify-center w-5 h-5 relative">
  <input type="checkbox" name=""
         :id="fieldId"
         :checked="checked"
         @input="(event) => $emit('update:checked', event.target.checked)"
         class="peer opacity-0 w-full h-full cursor-pointer border-0 bg-no-repeat bg-transparent focus:outline-none focus:ring-offset-0 ring-transparent shadow-none focus:ring-0 ring-red-cardinal text-transparent bg-input-checkbox-two checked:bg-input-checkbox-two-active checked:w-23px checked:h-23px"/>
  <div class="invisible peer-checked:visible absolute inset-0 w-full h-full z-10">
    <svg width="22" height="21" viewBox="0 0 22 21"
         xmlns="http://www.w3.org/2000/svg">
      <g fill-rule="nonzero" fill="none">
        <path d="M13.9932562,1.02986461 C14.5455293,1.0263069 14.9961366,1.47111127 14.9997158,2.02338443 C15.0030393,2.5362095 14.6197464,2.96137373 14.1227925,3.02236069 L14.0062174,3.02984406 L4,3.09467104 C2.9456382,3.09467104 2.08183488,3.91054883 2.00548574,4.9454087 L2,5.09467104 L2,16.2744062 C2,17.328768 2.81587779,18.1925713 3.85073766,18.2689205 L4,18.2744062 L13.9448776,18.2744062 C14.9992394,18.2744062 15.8630427,17.4585284 15.9393946,16.4214941 L15.9448808,16.271906 L15.9622033,9.34345068 C15.9635841,8.79116766 16.4124173,8.34457318 16.9647004,8.345954 C17.4775346,8.34723619 17.8992394,8.73433193 17.9557609,9.23181349 L17.962197,9.34845107 L17.9448776,16.2744062 C17.9448776,18.4166016 16.2609092,20.1654851 14.144518,20.2695109 L13.9448776,20.2744062 L4,20.2744062 C1.85780461,20.2744062 0.108921124,18.5904378 0.00489530723,16.4740466 L0,16.2744062 L0,5.09467104 C0,2.95247565 1.68396847,1.20359217 3.7944505,1.0995855 L3.99351937,1.09469204 L13.9932562,1.02986461 Z"
              fill="#000000"
              transform="translate(-545.000000, -521.000000) translate(0.000000, 341.000000) translate(545.495316, 180.270508)"/>
        <path d="M18.825758,0.384719778 C19.30364,-0.113497147 20.0949245,-0.129981852 20.5931414,0.347900158 C21.0581439,0.793923368 21.1035041,1.51295499 20.7189496,2.01191237 L20.629961,2.11528362 L9.23414424,13.9960171 C8.7896632,14.4594118 8.07367227,14.5062833 7.57462464,14.1252604 L7.47118442,14.0370591 L3.37645023,10.1477368 C2.87590136,9.67229793 2.85554569,8.88110352 3.33098459,8.38055464 C3.77472756,7.91337569 4.49352867,7.86449838 4.9943614,8.24660719 L5.09816677,8.335089 L8.29068445,11.366492 L18.825758,0.384719778 Z"
              fill="#BF1E2D"
              transform="translate(-545.000000, -521.000000) translate(0.000000, 341.000000) translate(545.495316, 180.270508)"/>
      </g>
    </svg>
  </div>
  <div class="peer-checked:invisible absolute inset-0 w-full h-full">
    <svg width="22" height="21" viewBox="0 0 22 21"
         xmlns="http://www.w3.org/2000/svg">
      <g fill-rule="nonzero" fill="none">
        <path d="M12.9997368,-0.220136642 L2.99351937,-0.155309658 C0.790861001,-0.155330658 -1,1.63553034 -1,3.84466934 L-1,15.0244045 C-1,17.2335435 0.790861001,19.0244045 3,19.0244045 L12.9448776,19.0244045 C15.1540166,19.0244045 16.9448776,17.2335435 16.9448776,15.0244045 L16.9622002,8.09844937 L16.9622002,3.74232674 C16.9622002,1.55391864 15.1881449,-0.220136642 12.9997368,-0.220136642 Z M3,1.84466934 L13,1.779 C14.0835754,1.77986336 14.9622002,2.65848814 14.9622002,3.74232674 L14.9622002,8.09594917 L14.9448808,15.0219043 C14.9448776,16.128974 14.0494471,17.0244045 12.9448776,17.0244045 L3,17.0244045 C1.8954305,17.0244045 1,16.128974 1,15.0244045 L1,3.84466934 C1,2.74009984 1.8954305,1.84466934 3,1.84466934 Z"
              fill="#000"
              transform="translate(-545.000000, -521.000000) translate(0.000000, 341.000000) translate(546.495316, 181.520510)"/>
      </g>
    </svg>
  </div>
</div>
<div class="select-none relative cursor-pointer filter" :class="{'grayscale': !checked}">
  <img v-if="image" :src="image" class="object-contain max-h-16 max-w-32" :alt="label" />
  <span v-else>{{label}}</span>
</div>
</label>
</template>

<script>
export default {
  name: "BrandCheckbox",
  props: {
    label: { type: String },
    fieldId: {
      type: String,
      required: true
    },
    image: String,
    checked: Boolean,
  },
}

</script>